import CandidateInfoPreview from "pages/ManagementPage/candiateInfoPreview/CandidateInfoPreview/CandidateInfoPreview";

export default CandidateInfoPreview;
